const UC_FLOCKLER_SERVICE = 'Flockler';

class ContentFlocklerFeed extends HTMLElement {

    constructor() {
        super();
        this.flocklerSrc = this.dataset['flocklerSrc'];
        this.flocklerContainer = this.querySelector('.flockler-container');
    }

    connectedCallback() {
        this.initEventListeners();
    }

    addFlocklerScript() {
        const script = document.createElement('script');
        script.src = this.flocklerSrc;
        script.async = 1;
        this.removeMissingConsentHints();
        this.flocklerContainer.insertAdjacentElement('afterend', script);
    }

    removeMissingConsentHints() {
        document.querySelectorAll('.missing-consent-hint').forEach((elem) => elem.setAttribute('hidden', ''));
    }

    initEventListeners() {
				window.addEventListener('UC_UI_INITIALIZED', () => {
						const flocklerOptIn = new DataLayerHelper(window.newDataLayer).get(UC_FLOCKLER_SERVICE);
						if (flocklerOptIn) {
								this.addFlocklerScript();
						}
				});

        if(!window.flocklerEventListener) {
            window.flocklerEventListener = true;
            window.addEventListener('ucEvent', (e) => {
                const { detail } = e;
                const { event, action } = detail;
                if (event === 'consent_status' && detail[UC_FLOCKLER_SERVICE] !== 'undefined' && action !== 'onInitialPageLoad' && action !== 'onMobileSessionRestore') {
                    location.reload();
                }
            });
        }
    }

    addCallbackForApp(action, param) {
        const callbackApp = createCallbackApp(action, param);
        this.insertAdjacentElement('afterbegin', callbackApp);
    }

}

if (!customElements.get('content-flockler-feed')) {
    customElements.define('content-flockler-feed', ContentFlocklerFeed);
}

export function createCallbackApp(action, param) {
    const callbackApp = document.createElement('callback-app');
    callbackApp.setAttribute('callback', action);
    if(param) {
        const { key, value } = param;
        const callbackParam = document.createElement('callback-param');
        callbackParam.setAttribute('key', key);
        callbackParam.setAttribute('value', value);
        callbackApp.appendChild(callbackParam);
    }
    return callbackApp;
}
